<template>
  <div class="page">

    <!--Title/Actions-->
    <div class="page-header flex-shrink-0 mb-3 bg-white border-bottom">
      <div class="container-fluid d-flex justify-content-between align-items-center px-md-4 px-3">
        <h3 class="mb-0">
          <i class="fas fa-users"></i>&nbsp;Users
        </h3>
        <div class="d-flex align-items-center">
          <div class="pr-3 d-md-block d-none">
            <b-form-checkbox v-model="showArchived" switch @input="toggleShowArchived"><span>Show
                Archived</span></b-form-checkbox>
          </div>
          <router-link title="New User" :to="{ name: 'CompanyPerson', params: { id: 'new' }}">
            <b-btn class="btn btn-success">
              <i class="fas fa-plus"></i> User
            </b-btn>
          </router-link>
        </div>
      </div>
    </div>

    <!--Search-->
    <div class="container-fluid px-md-4 px-3 py-3 bg-white border-bottom mb-3">
      <div class="row no-gutters">
        <div class="col-lg-4 col-md-6">
          <b-input-group>
            <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
          </b-input-group>
        </div>
        <b-button :disabled="!filter" variant="link" @click="filter = ''">Clear</b-button>
      </div>
    </div>

    <!--Table-->
    <div class="container-fluid flex-grow-1 overflow-auto px-md-4 px-3">
      <b-table id="people-table" bordered class="mb-5 rg-table" :items="peopleProvider" :fields="peopleTableData.fields"
        no-local-filtering :filter="filter" no-local-sorting :sortDesc.sync="sortDesc" :busy.sync="isBusy">
        <template v-slot:cell(name)="data">
          <div class="emphasis">
            {{ data.item.firstName }} {{ data.item.lastName }}
          </div>
        </template>
        <template v-slot:cell(position)="data">
          <div class="emphasis">
            {{ data.item.positionName }}
          </div>
        </template>
        <template v-slot:cell(phone)="data">
          <div class="emphasis">
            {{ data.item.phoneNumber }}
          </div>
        </template>
        <template v-slot:cell(email)="data">
          <div class="emphasis">
            {{ data.item.emailAddress }}
          </div>
        </template>
        <template v-slot:cell(isArchived)="data">
          <b-icon-archive v-if="data.item.isArchived" />
        </template>
        <template v-slot:cell(id)="data">
          <router-link class="btn btn-link" title="Edit User"
            :to="{ name: 'CompanyPerson', params: { id: data.item.id }}"><i class="fas fa-edit"></i></router-link>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {

  name: 'People',
  created () {
    this.fields = [
      {key: 'name', label: 'Name', sortable: true},
      {key: 'position', label: 'Position', sortable: true},
      {key: 'phone', label: 'Phone #', sortable: true},
      {key: 'email', label: 'Email', sortable: true},
      {key: 'isArchived', label: 'Archived', sortable: true},
      {key: 'id', label: 'Actions'}]
  },
  components: {
  },
  data () {
    return {
      fields: [],
      properties: [],
      isBusy: false,
      showArchived: false,
      sortBy: null,
      sortDirection: 'asc',
      filter: null,
      sortDesc: true
    }
  },
  computed: {
    peopleTableData () {
      var returnPeople = {
        fields: this.fields.filter(f => {
          return this.showArchived ? true : f.key !== 'isArchived'
        })
      }
      console.log(
        'Event Table Data is: ' +
          JSON.stringify(returnPeople, null, 2)
      )
      return returnPeople
    }
  },
  methods: {
    ...mapActions('company', [
      'getPeopleForManagement'
    ]),
    peopleProvider (ctx) {
      this.isBusy = true
      console.log(
        'people table ctx is: ' +
          JSON.stringify(ctx, null, 2)
      )
      var request = { sortBy: ctx.sortBy, sortDirection: ctx.sortDesc ? 'desc' : 'asc', showArchived: this.showArchived, search: ctx.filter }

      // Must return a promise that resolves to an array of items
      return this.getPeopleForManagement(request).then(r => {
        // Pluck the array of items off our axios response
        const items = r.data.people
        console.log(
          'Returned Table Data is: ' +
          JSON.stringify(items, null, 2)
        )
        this.isBusy = false
        // Must return an array of items or an empty array if an error occurred
        return items || []
      })
    },
    toggleShowArchived (value) {
      this.$root.$emit('bv::refresh::table', 'people-table')
    }
  }
}
</script>

<style>
.ui.modals.active .modal {
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/setup/People.vue